<template>
    <div class="main-container">
        <v-row class="justify-center mb-4">
            <v-img
                max-width="180px"
                src="../assets/sesi-logo.png"
                style="cursor: pointer;"
            ></v-img>
        </v-row>

        <v-row class="justify-center">
            <v-col cols="12" md="12">
                <v-card class="pa-4">
                    <h3 class="text-center primary--text font-weight-bold mb-4">
                        SELECIONE A UNIDADE
                    </h3>

                    <v-autocomplete
                        v-model="IdUnidadeSelecionado"
                        :items="unidadesList"
                        item-text="Unidade"
                        item-value="IdUnidade"
                        label="Escolha uma unidade"
                        @change="onUnitChange"
                        hide-details
                        outlined
                        dense
                        clearable
                        class="mb-4"
                        :loading="loadingUnidades"
                        :disabled="loadingUnidades"
                    ></v-autocomplete>

                    <v-btn
                        color="primary"
                        @click="confirmSelection"
                        block
                        dark
                    >
                        Selecionar
                    </v-btn>

                    <v-alert
                        v-if="selectedUnit"
                        type="info"
                        class="mt-4"
                        style="color: black;"
                    >
                        Unidade selecionada: <strong>{{ getSelectedUnitName }}</strong>
                    </v-alert>
                </v-card>
            </v-col>
        </v-row>
        <AlertSystem :snackbar="system.snackbar"></AlertSystem>
    </div>
</template>

<script>
import axios from 'axios';
import AlertSystem from "../components/AlertSystem";

export default {
    components:{
        AlertSystem,
    },
    data() {
        return {
            unidadesList: [],
            IdUnidadeSelecionado: null,
            selectedUnit: null,
            loadingUnidades: false,
            system: {
                snackbar: {},
            },
        };
    },
    computed: {
        getSelectedUnitName() {
            const unidade = this.unidadesList.find(u => u.IdUnidade === this.IdUnidadeSelecionado);
            return unidade ? unidade.Unidade : '';
        },
    },
    methods: {
        async fetchUnidades() {
            this.loadingUnidades = true;
            try {
                const response = await axios.get('senharecepcao/unidades');
                this.unidadesList = response.data;
            } catch {                
                alert('Não foi possível carregar a lista de unidades. Tente novamente mais tarde.');
            } finally {
                this.loadingUnidades = false;
            }
        },
        onUnitChange() {
            this.selectedUnit = this.unidadesList.find(u => u.IdUnidade === this.IdUnidadeSelecionado);
        },
        confirmSelection() {
            if (this.selectedUnit) {
                this.$router.push({
                    path: '/atendimentoPainel',
                    query: {
                        Unidade: this.selectedUnit.Unidade,
                        IdUnidade: this.selectedUnit.IdUnidade,
                    },
                });
            } else {
                this.system.snackbar = {
                    snackbar: true,
                    text: 'Por favor, selecione uma unidade antes de continuar.',
                    color: "red",
                };
            }
        },
    },
    mounted() {
        this.fetchUnidades();
    },
};
</script>

<style scoped>
.main-container {
    max-width: 600px;
    margin: 0 auto;
    padding: 20px;
}
</style>
